<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <div class="row">
          <div class="col-lg-3 col-md-6 col-12">
            <card
              title="Total Employees"
              :value="totalKaryawan"
              detail=""
              iconClass="ni ni-single-02"
              iconBackground="bg-gradient-primary"
              directionReverse
            ></card>
          </div>
          <div class="col-lg-3 col-md-6 col-12">
            <card
              title="This Month's Salary"
              :value="'Rp ' + convertRp(totalGajiBulanIni)"
              :percentage="salaryChangeLabel"
              :percentageColor="salaryChangeColor"
              detail="vs bulan lalu"
              iconClass="fa fa-usd"
              iconBackground="bg-gradient-danger"
              directionReverse
            ></card>
          </div>
          <div class="col-lg-3 col-md-6 col-12">
            <card
              title="Last Month's Salary"
              :value="'Rp ' + convertRp(totalGajiBulanLalu)"
              detail=""
              iconClass="ni ni-paper-diploma"
              iconBackground="bg-gradient-success"
              directionReverse
            ></card>
          </div>
          <div class="col-lg-3 col-md-6 col-12">
            <card
              title="Total Users"
              :value="totalUsers"
              detail=""
              iconClass="ni ni-satisfied"
              iconBackground="bg-gradient-warning"
              directionReverse
            ></card>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-7 mb-lg mb-4">
            <div class="card z-index-2 h-100">
              <div class="pb-0 card-header">
                <p class="font-weight-bold mb-0"><i class="fa fa-line-chart text-primary me-1"></i> Tren Gaji per Periode</p>
                <p class="text-sm text-secondary mb-0">6 periode payroll terakhir</p>
              </div>
              <div class="p-3 card-body">
                <div class="chart" style="height: 260px;">
                  <canvas id="chart-gaji-trend" class="chart-canvas"></canvas>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-5 mb-4">
            <div class="card h-100">
              <div class="pb-0 card-header">
                <p class="font-weight-bold mb-0"><i class="fa fa-users text-info me-1"></i> Karyawan per Unit</p>
                <p class="text-sm text-secondary mb-0">Total {{ totalKaryawan }} karyawan</p>
              </div>
              <div class="p-3 card-body">
                <div class="chart" style="height: 260px;">
                  <canvas id="chart-karyawan-unit" class="chart-canvas"></canvas>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-lg-3 mb-4">
            <div class="card h-100">
              <div class="pb-0 card-header">
                <p class="font-weight-bold mb-0"><i class="fa fa-venus-mars text-danger me-1"></i> Gender Diversity</p>
                <p class="text-sm text-secondary mb-0">Jenis kelamin</p>
              </div>
              <div class="p-3 card-body">
                <div class="chart" style="height: 220px;">
                  <canvas id="chart-gender" class="chart-canvas"></canvas>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 mb-4">
            <div class="card h-100">
              <div class="pb-0 card-header">
                <p class="font-weight-bold mb-0"><i class="fa fa-id-card text-warning me-1"></i> Employee Status</p>
                <p class="text-sm text-secondary mb-0">Tipe kepegawaian</p>
              </div>
              <div class="p-3 card-body">
                <div class="chart" style="height: 220px;">
                  <canvas id="chart-employee-status" class="chart-canvas"></canvas>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 mb-4">
            <div class="card h-100">
              <div class="pb-0 card-header">
                <p class="font-weight-bold mb-0"><i class="fa fa-calendar-check text-success me-1"></i> Length of Service</p>
                <p class="text-sm text-secondary mb-0">Masa kerja karyawan (berdasarkan tanggal masuk)</p>
              </div>
              <div class="p-3 card-body">
                <div class="chart" style="height: 220px;">
                  <canvas id="chart-tenure" class="chart-canvas"></canvas>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- DASHBOARD TELAT DAN PULANG CEPAT -->
        <div class="row mt-4">
          <div class="col-6 mb-lg-0 mb-4">
            <div class="card">
              <div class="card-header bg-gradient-danger">
                <div class="row">
                  <div class="col-3">
                    <div class=" pb-0">
                      <h6 class="text-white mb-0"><i class="fa fa-clock me-1"></i> Employees are late</h6>
                    </div>
                  </div>
                  <div class="col-4">
                    
                  </div>
                  <div class="col-5 float-right">
                    <argon-button
                      variant="gradient"
                      color="secondary"
                      size="sm"
                      @click="filterTelat()"
                    ><i class="fa fa-filter fa-sm" aria-hidden="true"></i> Filter</argon-button>
                    <a class="btn btn-sm btn-warning" style="margin-top: 12px; margin-left: 20px;" :href="apiUrl+'print-pdf/employee-telat?start_date='+searchTelat.start_date+'&end_date='+searchTelat.end_date+'&nama='+searchTelat.nama+'&jabatan='+searchTelat.jabatan+'&unit='+searchTelat.unit+''" target="_BLANK"><i class="fa fa-print fa-sm"></i> Print</a>
                  </div>
                </div>
              </div>
              <div class="table-responsive scroll">
                <table class="table align-items-center table-striped">
                  <thead>
                    <tr>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Nama</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder  ps-2">Unit</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">JABATAN</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">DATE</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">SHIFT</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">FINGER TIME</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">LATE</th>
                      <th class="text-secondary"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, i) in tableTelat.data" :key="i">
                      <td class="w-30">
                        <div class="px-2 py-1 d-flex align-items-center">
                          <!-- <div>
                            <img src="" />
                          </div> -->
                          <div class="ms-4">
                            <p class="mb-0 text-xs font-weight-bold">{{ row.id_karyawan }}</p>
                            <h6 class="mb-0 text-sm">{{ row.nama }}</h6>
                          </div>
                        </div>
                      </td>
                      <td>
                          <span class="text-secondary text-xs font-weight-bold">{{ row.unit }}</span>
                      </td>
                      <td>
                          <span class="text-secondary text-xs font-weight-bold">{{ row.jabatan }}</span>
                      </td>
                      <td class="text-sm align-middle text-center">
                          <span class="text-secondary text-xs font-weight-bold">{{ moment(row.date).locale('id').format('LL') }}</span>
                      </td>
                      <td class="align-middle text-center">
                          <span class="text-secondary text-xs font-weight-bold">{{ row.shift }}</span>
                      </td>
                      <td class="align-middle text-center">
                          <span class="text-secondary text-xs font-weight-bold">{{ row.time }}</span>
                      </td>
                      <td class="text-sm align-middle text-center">
                          <span class="text-secondary text-xs font-weight-bold">{{ row.telat }} Menit</span>
                      </td>
                      <td class="text-secondary"></td>
                    </tr>
                    <tr v-if="tableTelat.data.length == 0">
                      <td colspan="8" class="text-center text-sm py-4 text-secondary">Tidak ada karyawan terlambat</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="card-footer">
              </div>
            </div>
          </div>

          <div class="col-6 mb-lg-0 mb-4">
            <div class="card">
              <div class="card-header bg-gradient-info">
                <div class="row">
                  <div class="col-4">
                    <div class=" pb-0">
                      <h6 class="text-white mb-0"><i class="fa fa-sign-out-alt me-1"></i> Employees go home early</h6>
                    </div>
                  </div>
                  <div class="col-3">
                  </div>
                  <div class="col-5 float-right">
                    <argon-button
                      variant="gradient"
                      color="secondary"
                      size="sm"
                      @click="filterTelat()"
                    ><i class="fa fa-filter fa-sm" aria-hidden="true"></i> Filter</argon-button>
                    <a class="btn btn-sm btn-warning" style="margin-top: 12px; margin-left: 20px;" :href="apiUrl+'print-pdf/employee-pulang-cepat?start_date='+searchTelat.start_date+'&end_date='+searchTelat.end_date+'&nama='+searchTelat.nama+'&jabatan='+searchTelat.jabatan+'&unit='+searchTelat.unit+''" target="_BLANK"><i class="fa fa-print fa-sm"></i> Print</a>
                  </div>
                </div>
              </div>
              <div class="table-responsive scroll">
                <table class="table align-items-center table-striped">
                  <thead>
                    <tr>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Nama</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder  ps-2">Unit</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">JABATAN</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">DATE</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">SHIFT</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">FINGER TIME</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">LATE</th>
                      <th class="text-secondary"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, i) in tablePulangCepat.data" :key="i">
                      <td class="w-30">
                        <div class="px-2 py-1 d-flex align-items-center">
                          <!-- <div>
                            <img src="" />
                          </div> -->
                          <div class="ms-4">
                            <p class="mb-0 text-xs font-weight-bold">{{ row.id_karyawan }}</p>
                            <h6 class="mb-0 text-sm">{{ row.nama }}</h6>
                          </div>
                        </div>
                      </td>
                      <td>
                          <span class="text-secondary text-xs font-weight-bold">{{ row.unit }}</span>
                      </td>
                      <td>
                          <span class="text-secondary text-xs font-weight-bold">{{ row.jabatan }}</span>
                      </td>
                      <td class="text-sm align-middle text-center">
                          <span class="text-secondary text-xs font-weight-bold">{{ moment(row.date).locale('id').format('LL') }}</span>
                      </td>
                      <td class="align-middle text-center">
                          <span class="text-secondary text-xs font-weight-bold">{{ row.shift }}</span>
                      </td>
                      <td class="align-middle text-center">
                          <span class="text-secondary text-xs font-weight-bold">{{ row.time }}</span>
                      </td>
                      <td class="text-sm align-middle text-center">
                          <span class="text-secondary text-xs font-weight-bold">{{ row.telat }} Menit</span>
                      </td>
                      <td class="text-secondary"></td>
                    </tr>
                    <tr v-if="tablePulangCepat.data.length == 0">
                      <td colspan="8" class="text-center text-sm py-4 text-secondary">Tidak ada karyawan pulang cepat</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="card-footer">
              </div>
            </div>
          </div>
        </div>

        <!-- Employee Hour Performance -->
        <div class="row mt-4">
          <div class="col-lg-12 mb-lg-0 mb-4">
            <div class="card">
              <div class="row mb-4">
                <div class="col-4">
                  <div class="card-header pb-0">
                    <h6 class="mb-0"><i class="fa fa-hourglass-half text-warning me-1"></i> Employee Hour Performance</h6>
                    <p class="text-sm text-secondary mb-0">Periode berjalan</p>
                  </div>
                </div>
                <div class="col-4">
                </div>
                <div class="col-4 float-right">
                  <argon-button
                    style="margin-right: 10px; margin-left: 60px;"
                    class="mt-4"
                    variant="gradient"
                    color="secondary"
                    size="sm"
                    @click="filter()"
                  ><i class="fa fa-filter fa-sm" aria-hidden="true"></i> Filter</argon-button>
                  <a class="btn btn-sm btn-warning" style="margin-top: 40px;" :href="apiUrl+'print-pdf/ehp?periode_start='+search.periode_start+'&periode_end='+search.periode_end+'&nama='+search.nama+'&jabatan='+search.jabatan+'&unit='+search.unit+''" target="_BLANK"><i class="fa fa-print fa-sm"></i> Print</a>
                </div>
              </div>
              <div class="table-responsive scroll">
                <table class="table align-items-center table-striped">
                  <thead>
                    <tr>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Nama</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder  ps-2">Unit</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">JABATAN</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">JAM KERJA</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">JAM LEMBUR</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">TOTAL JAM</th>
                      <th class="text-secondary"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, i) in table.data" :key="i">
                      <td class="w-30">
                        <div class="px-2 py-1 d-flex align-items-center">
                          <!-- <div>
                            <img src="" />
                          </div> -->
                          <div class="ms-4">
                            <p class="mb-0 text-xs font-weight-bold">{{ row.id_karyawan }}</p>
                            <h6 class="mb-0 text-sm">{{ row.nama }}</h6>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="text-left">
                          <h6 class="mb-0 text-sm">{{ row.unit }}</h6>
                        </div>
                      </td>
                      <td>
                        <div class="text-left">
                          <h6 class="mb-0 text-sm">{{ row.jabatan }}</h6>
                        </div>
                      </td>
                      <td class="text-sm align-middle">
                        <div class="text-center col">
                          <h6 class="mb-0 text-sm"> {{ (8 * row.total_kerja_count) }}</h6>
                        </div>
                      </td>
                      <td class="text-sm align-middle">
                        <div class="text-center col">
                          <h6 class="mb-0 text-sm">{{ row.total_ot_count }}</h6>
                        </div>
                      </td>
                      <td class="text-sm align-middle">
                        <div class="text-center col">
                          <h6 class="mb-0 text-sm">{{ (+(8 * row.total_kerja_count) + +(row.total_ot_count)) }}</h6>
                        </div>
                      </td>
                      <td class="text-secondary"></td>
                    </tr>
                    <tr v-if="table.data.length == 0">
                      <td colspan="7" class="text-center text-sm py-4 text-secondary">Tidak ada data</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="card-footer">
            </div>
            </div>
          </div>
        </div>

        <!-- =======  MODAL FILTER TELAT ======= -->
        <div class="container">
          <vue-final-modal v-model="formFilterTelat.show" classes="modal-container" content-class="modal-content" :z-index="10000">
            <!-- header -->
            <div class="row">
              <div class="col-11 float-left">
                <span class="modal__title">{{formFilterTelat.title}}</span>
              </div>
              <div class="col-1 float-right">
                <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formFilterTelat.show = false"></i>
              </div>
            </div><hr>
            <!-- end header -->
            <div class="modal__content container">
              <label for="example-text-input" class="form-control-label mt-3">Start Date</label>
              <input type="date" class="form-control" placeholder="Start Date" v-model="searchTelat.start_date">
              <label for="example-text-input" class="form-control-label mt-3">End Date</label>
              <input type="date" class="form-control" placeholder="End Date" v-model="searchTelat.end_date">
              <label for="example-text-input" class="form-control-label mt-3">Nama</label>
              <input type="text" class="form-control" placeholder="Nama" v-model="searchTelat.nama">
              <label for="example-text-input" class="form-control-label mt-3">Jabatan</label>
              <input type="text" class="form-control" placeholder="Jabatan" v-model="searchTelat.jabatan">
              <label for="example-text-input" class="form-control-label mt-3">Unit</label>
              <input type="text" class="form-control" placeholder="Unit" v-model="searchTelat.unit">
            </div>
            <!-- footer -->
            <div class="row float-right mt-3">
              <div class="col-6"> 
              </div>
              <div class="col-2" style="margin-right: 20px;">
                <argon-button  variant="gradient" color="secondary" size="sm" width="1" @click="formFilterTelat.show = true">Close</argon-button>
              </div>
              <div class="col-1">
                <argon-button variant="gradient" color="success" size="sm" width="1" @click="getTelat()">Filter</argon-button>
              </div>
            </div>
            <!-- end footer -->
          </vue-final-modal>
        </div>

        <!-- =======  MODAL FILTER ======= -->
        <div class="container">
          <vue-final-modal v-model="formFilter.show" classes="modal-container" content-class="modal-content" :z-index="10000">
            <!-- header -->
            <div class="row">
              <div class="col-11 float-left">
                <span class="modal__title">{{formFilter.title}}</span>
              </div>
              <div class="col-1 float-right">
                <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formFilter.show = false"></i>
              </div>
            </div><hr>
            <!-- end header -->
            <div class="modal__content container">
              <label for="example-text-input" class="form-control-label mt-3">Periode</label>
              <input type="month" class="form-control" v-model="search.periode" @change="onPeriodeFilterChange()">
              <label for="example-text-input" class="form-control-label mt-3">Nama</label>
              <input type="text" class="form-control" placeholder="Nama" v-model="search.nama" required>
              <label for="example-text-input" class="form-control-label mt-3">Jabatan</label>
              <input type="text" class="form-control" placeholder="Jabatan" v-model="search.jabatan" required>
              <label for="example-text-input" class="form-control-label mt-3">Unit</label>
              <input type="text" class="form-control" placeholder="Unit" v-model="search.unit" required>
            </div>
            <!-- footer -->
            <div class="row float-right mt-3">
              <div class="col-6"> 
              </div>
              <div class="col-2" style="margin-right: 20px;">
                <argon-button  variant="gradient" color="secondary" size="sm" width="1" @click="formFilter.show = true">Close</argon-button>
              </div>
              <div class="col-1">
                <argon-button variant="gradient" color="success" size="sm" width="1" @click="getEhp()">Filter</argon-button>
              </div>
            </div>
            <!-- end footer -->
          </vue-final-modal>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import Card from "@/examples/Cards/Card.vue";
import { VueFinalModal } from 'vue-final-modal'
import ArgonButton from "@/components/ArgonButton.vue";
import Api from '@/helpers/api';
var moment = require('moment');
import config from '@/configs/config';
import dashboard from '@/services/dashboard.service';
import akun from '@/services/akun.service';
import { periodeToRange } from '@/helpers/periode';
import Chart from 'chart.js/auto';

export default {
  name: "dashboard-default",
  data() {
    return {
      moment:moment,
      table: {
        data: []
      },
      tableTelat: {
        data: []
      },
      tablePulangCepat: {
        data: []
      },
      totalKaryawan: '',
      totalGajiBulanIni: '',
      totalGajiBulanLalu: '',
      totalUsers: '',
      gajiTrend: [],
      karyawanByUnit: [],
      genderDiversity: [],
      lengthOfService: [],
      employeeStatus: [],
      chartGaji: null,
      chartUnit: null,
      chartGender: null,
      chartTenure: null,
      chartEmployeeStatus: null,
      formFilter: {
        add: true,
        title: "Filter",
        show: false
      },
      formFilterTelat: {
        add: true,
        title: "Filter",
        show: false
      },
      search: {
        periode: '',
        periode_start: '',
        periode_end: '',
        nama: '',
        jabatan: '',
        unit: '',
      },
      searchTelat: {
        start_date: '',
        end_date: '',
        nama: '',
        jabatan: '',
        unit: '',
      },
      apiUrl :config.apiUrl,
      role: '',
    };
  },
  computed: {
    salaryChangeLabel() {
      if (!this.totalGajiBulanLalu) return '';
      const diff = ((this.totalGajiBulanIni - this.totalGajiBulanLalu) / this.totalGajiBulanLalu) * 100;
      return (diff >= 0 ? '+' : '') + diff.toFixed(1) + '%';
    },
    salaryChangeColor() {
      if (!this.totalGajiBulanLalu) return 'text-secondary';
      return this.totalGajiBulanIni >= this.totalGajiBulanLalu ? 'text-success' : 'text-danger';
    },
  },
  components: {
    Card,
    ArgonButton,
    VueFinalModal,
  },
  mounted(){
    this.get();
    this.getEhp();
    this.getTelat();
    this.getRole();
  },
  methods: {
    get(param){
      let context = this;               
      Api(context, dashboard.index()).onSuccess(function(response) {    
          context.table.data         = response.data.data.EHP;
          context.totalKaryawan      = response.data.data.totalKaryawan;
          context.totalGajiBulanIni  = response.data.data.totalGajiBulanIni;
          context.totalGajiBulanLalu = response.data.data.totalGajiBulanLalu;
          context.totalUsers         = response.data.data.totalUsers;
          context.gajiTrend          = response.data.data.gajiTrend;
          context.karyawanByUnit     = response.data.data.karyawanByUnit;
          context.genderDiversity    = response.data.data.genderDiversity;
          context.lengthOfService    = response.data.data.lengthOfService;
          context.employeeStatus     = response.data.data.employeeStatus;
      }).onError(function(error) {
          if (error.response.status == 404) {
              context.table.data = [];
          }
      }).onFinish(function() {
         context.renderCharts();
      })
      .call()
    },
    getEhp(param){
      let context = this;               
      Api(context, dashboard.showEhp({ periode_start: context.search.periode_start, periode_end: context.search.periode_end, nama: context.search.nama, jabatan: context.search.jabatan, unit: context.search.unit})).onSuccess(function(response) {    
          context.table.data = response.data.data.EHP;
      }).onError(function(error) {                    
          if (error.response.status == 404) {
              context.table.data = [];
          }
      }).onFinish(function() { 
         context.formFilter.show  = false;
      })
      .call()
    },
    getTelat(param){
      let context = this;               
      Api(context, dashboard.logTelat({nama: context.searchTelat.nama, jabatan: context.searchTelat.jabatan, unit: context.searchTelat.unit, start_date: context.searchTelat.start_date, end_date: context.searchTelat.end_date})).onSuccess(function(response) {    
          context.tableTelat.data       = response.data.data.dataTelat;
          context.tablePulangCepat.data = response.data.data.dataPulangCepat;
      }).onError(function(error) {                    
          if (error.response.status == 404) {
              context.tableTelat.data = [];
          }
      }).onFinish(function() { 
         context.formFilterTelat.show  = false;
      })
      .call()
    },
    getRole(){
      let context = this;     
      context.onLoading = true;
      Api(context, akun.indexProfile()).onSuccess(function(response) {
          context.role = response.data.data[0].role;
          if (response.data.data[0].role != 'Admin') {
            context.$router.push({ path: /detail-profile/+response.data.data[0].employee_id})
          }
      }).onError(function(error) {  
      })
      .call() 
    },
    convertRp(bilangan) {
      if (bilangan) {
        var number_string = bilangan.toString(),
            sisa    = number_string.length % 3,
            rupiah  = number_string.substr(0, sisa),
            ribuan  = number_string.substr(sisa).match(/\d{3}/g);

        if(ribuan){
          var separator = sisa ? '.' : '';
          rupiah += separator + ribuan.join('.');
          return rupiah
        }else{
          return bilangan
        }
      }
      return 0;
    },
    renderCharts() {
      let context = this;
      this.$nextTick(function() {
        // ==== TREN GAJI PER PERIODE ====
        const ctxGaji = document.getElementById('chart-gaji-trend');
        if (ctxGaji) {
          if (context.chartGaji) { context.chartGaji.destroy(); }
          const gradient = ctxGaji.getContext('2d').createLinearGradient(0, 0, 0, 230);
          gradient.addColorStop(0, 'rgba(94, 114, 228, 0.3)');
          gradient.addColorStop(1, 'rgba(94, 114, 228, 0)');

          context.chartGaji = new Chart(ctxGaji, {
            type: 'line',
            data: {
              labels: context.gajiTrend.map(r => r.periode),
              datasets: [{
                label: 'Total Gaji',
                data: context.gajiTrend.map(r => r.total),
                tension: 0.4,
                borderColor: '#5e72e4',
                backgroundColor: gradient,
                borderWidth: 3,
                pointRadius: 3,
                pointBackgroundColor: '#5e72e4',
                fill: true,
              }],
            },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              plugins: {
                legend: { display: false },
                tooltip: {
                  callbacks: {
                    label: function(item) { return 'Rp ' + context.convertRp(item.raw); }
                  }
                }
              },
              scales: {
                y: {
                  ticks: {
                    callback: function(value) { return context.convertRp(value); }
                  }
                }
              }
            }
          });
        }

        // ==== KARYAWAN PER UNIT ====
        const ctxUnit = document.getElementById('chart-karyawan-unit');
        if (ctxUnit) {
          if (context.chartUnit) { context.chartUnit.destroy(); }
          const palette = ['#5e72e4','#2dce89','#11cdef','#fb6340','#f5365c','#ffd600','#8965e0','#f3a4b5'];

          context.chartUnit = new Chart(ctxUnit, {
            type: 'doughnut',
            data: {
              labels: context.karyawanByUnit.map(r => r.unit),
              datasets: [{
                data: context.karyawanByUnit.map(r => r.total),
                backgroundColor: context.karyawanByUnit.map((r, i) => palette[i % palette.length]),
                borderWidth: 0,
              }],
            },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              cutout: '65%',
              plugins: {
                legend: {
                  position: 'right',
                  labels: { boxWidth: 10, font: { size: 11 } }
                }
              }
            }
          });
        }

        // ==== GENDER DIVERSITY ====
        const ctxGender = document.getElementById('chart-gender');
        if (ctxGender) {
          if (context.chartGender) { context.chartGender.destroy(); }
          const genderPalette = { 'Laki - Laki': '#11cdef', 'Perempuan': '#f5365c', 'Belum Diisi': '#adb5bd' };

          context.chartGender = new Chart(ctxGender, {
            type: 'doughnut',
            data: {
              labels: context.genderDiversity.map(r => r.label),
              datasets: [{
                data: context.genderDiversity.map(r => r.total),
                backgroundColor: context.genderDiversity.map(r => genderPalette[r.label] || '#adb5bd'),
                borderWidth: 0,
              }],
            },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              cutout: '65%',
              plugins: {
                legend: {
                  position: 'bottom',
                  labels: { boxWidth: 10, font: { size: 11 } }
                }
              }
            }
          });
        }

        // ==== LENGTH OF SERVICE ====
        const ctxTenure = document.getElementById('chart-tenure');
        if (ctxTenure) {
          if (context.chartTenure) { context.chartTenure.destroy(); }

          context.chartTenure = new Chart(ctxTenure, {
            type: 'bar',
            data: {
              labels: context.lengthOfService.map(r => r.label),
              datasets: [{
                label: 'Jumlah Karyawan',
                data: context.lengthOfService.map(r => r.total),
                backgroundColor: '#2dce89',
                borderRadius: 6,
                maxBarThickness: 40,
              }],
            },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              plugins: { legend: { display: false } },
              scales: {
                y: { beginAtZero: true, ticks: { precision: 0 } }
              }
            }
          });
        }

        // ==== EMPLOYEE STATUS (TIPE KEPEGAWAIAN) ====
        const ctxStatus = document.getElementById('chart-employee-status');
        if (ctxStatus) {
          if (context.chartEmployeeStatus) { context.chartEmployeeStatus.destroy(); }
          const statusPalette = { 'Permanent': '#2dce89', 'Kontrak': '#fb6340', 'Harian': '#11cdef', 'Belum Diisi': '#adb5bd' };

          context.chartEmployeeStatus = new Chart(ctxStatus, {
            type: 'doughnut',
            data: {
              labels: context.employeeStatus.map(r => r.label),
              datasets: [{
                data: context.employeeStatus.map(r => r.total),
                backgroundColor: context.employeeStatus.map(r => statusPalette[r.label] || '#adb5bd'),
                borderWidth: 0,
              }],
            },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              cutout: '65%',
              plugins: {
                legend: {
                  position: 'bottom',
                  labels: { boxWidth: 10, font: { size: 11 } }
                }
              }
            }
          });
        }
      });
    },
    filter() {
      this.formFilter.add   = true;
      this.formFilter.show  = true;
      this.formFilter.title = "Filter";
      this.onLoading = false;
      this.search.periode   = this.search.periode_start ? moment(this.search.periode_start).format('YYYY-MM') : '';
    },
    onPeriodeFilterChange() {
      const range = periodeToRange(this.search.periode);
      this.search.periode_start = range.start;
      this.search.periode_end   = range.end;
    },
    filterTelat() {
      this.formFilterTelat.add   = true;
      this.formFilterTelat.show  = true;
      this.formFilterTelat.title = "Filter";
      this.onLoading = false;
    },
  }
};
</script>
<style scoped>
::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;

}
::v-deep .modal-content {
  display: flex;
  flex-direction: column;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  width: 500px;
  max-width: 95vw;
  max-height: 90vh;
  overflow-y: auto;
  margin-top: auto;
  margin-bottom: auto;
}
.modal__title {
  font-size: 1rem;
  font-weight: 600;
}
</style>

<style scoped>
.dark-mode div::v-deep .modal-content {
  border-color: #2d3748;
  background-color: #1a202c;
}
.scroll {
  overflow: auto;
  max-height: 420px;
  border-bottom-left-radius: 0.75rem;
  border-bottom-right-radius: 0.75rem;
}
.scroll thead th {
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: #F0F8FF;
}
.scroll::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}
.scroll::-webkit-scrollbar-track {
  background: transparent;
}
.scroll::-webkit-scrollbar-thumb {
  background-color: #d3d9e6;
  border-radius: 10px;
}
.scroll::-webkit-scrollbar-thumb:hover {
  background-color: #b6bfd4;
}
</style>
